// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gz-0";
export var actionModalContentContainer = "_gz-1";
export var createTagButton = "_gz-2";
export var footerContainer = "_gz-7";
export var fullWidthDivider = "_gz-3";
export var hasCreateTagButton = "_gz-4";
export var noCreateTagButton = "_gz-5";
export var tagsContainer = "_gz-6";
export var tagsModalContentContainer = "_gz-8";